export default __webpack_public_path__ + "static/media/IMG_2349.422c2d23.jpg";